/* Reuse published Shopify cards and technical data, never infer stock from portal text. */
(() => {
 'use strict';
 const data=window.KleverTechnicalData;
 const cache=new Map();
 const normal=s=>data.normalize(s);
 function exactCategory(query,scope,categories){
  const q=normal(query).replace(/^sensor(?:es)?\s+/,'');
  const category=!query.trim()&&scope?categories.find(c=>String(c.id)===scope):categories.find(c=>{
   const name=normal(c.name);
   return normal(query)===name||q===name||(!name.includes(' ')&&q===name.replace(/s$/,''))||name==='sensores'&&normal(query)==='sensor';
  });
  if(!category)return null;
  let parent=category;
  while(scope&&parent&&String(parent.id)!==scope)parent=categories.find(c=>c.id===parent.parentId);
  return scope&&!parent?null:category;
 }
 function resultCategory(items,catalogCategory,categories){
  const root=category=>{
   const visited=new Set();
   while(category?.parentId){if(visited.has(category.id))return null;visited.add(category.id);category=categories.find(c=>c.id===category.parentId);}
   return category||null;
  };
  if(catalogCategory)return root(categories.find(c=>String(c.id)===String(catalogCategory)));
  if(!items.length)return null;
  const roots=items.map(p=>root(categories.find(c=>normal(c.name)===normal(p.category))));
  return roots.every(c=>c&&c.id===roots[0]?.id)?roots[0]:null;
 }
 function record(node){
  const meta=JSON.parse(node.querySelector('[data-product-technical]').textContent);
  const title=node.querySelector('.kb-product-row__title').textContent.trim();
  const sku=node.querySelector('.kb-product-row__sku strong')?.textContent.trim()||'';
  if(!node.dataset.productId)return null;
  const url=new URL(node.querySelector('.kb-product-row__title').getAttribute('href'),location.origin);
  if(url.origin!==location.origin||!url.pathname.startsWith('/products/'))return null;
  const fields=data.extract(meta.description,{title,type:meta.type,category:meta.type});
  const delivery=data.deliveryWindow(meta.delivery);
  const attributes=Object.entries(fields).flatMap(([key,value])=>(Array.isArray(value)?value:[value]).filter(Boolean).map(value=>({key,label:({Salida:'Salida detallada',Conexión:'Conexión detallada'}[key]||key),value:String(value)})));
  if(delivery)attributes.push({key:'delivery',label:'Plazo de entrega',value:delivery});
  const description=new DOMParser().parseFromString(meta.description||'','text/html');
  const documents=[...description.querySelectorAll('a[href]')].map(a=>({name:a.textContent.trim()||'Ficha técnica',url:a.href})).filter(d=>/^https:\/\//.test(d.url));
  const photo=node.querySelector('.kb-product-row__image>img');
  const imageUrl=photo?new URL(photo.getAttribute('src'),location.origin).href:'';
  const facts=node.querySelector('.kb-card-facts');
  const availability=facts?.querySelector('.kb-card-fact:nth-child(2) strong')?.textContent.trim()||'Confirmar stock';
  // Technical JSON is read above; keep only the storefront markup that customers see.
  node.querySelectorAll('script').forEach(s=>s.remove());
  node.querySelectorAll('[data-price],.kb-price').forEach(el=>{if(el.classList.contains('kb-price'))el.remove();else el.removeAttribute('data-price');});
  node.removeAttribute('data-price');
  const result={id:node.dataset.productId,sku,name:title,model:title,brand:meta.vendor,category:meta.type,url:url.href,imageUrl,availability,attributes,fields,documents,description:data.clean(description.querySelector('p')?.textContent||meta.description).slice(0,650),commercial:facts?.outerHTML||'',html:node.outerHTML};
  if(sku)cache.set(sku,result);return result;
 }
 async function page(url,signal,selector){
  const r=await fetch(url,{signal,credentials:'same-origin'});if(!r.ok)throw Error('No pudimos cargar las fichas publicadas. Intenta nuevamente.');
  const doc=new DOMParser().parseFromString(await r.text(),'text/html');
  const wrap=doc.querySelector(selector);if(!wrap)throw Error('No pudimos leer las fichas del catálogo. Intenta nuevamente.');
  return {items:[...wrap.querySelectorAll('[data-ks-product]')].map(record).filter(Boolean),total:Number(wrap.dataset.total),next:wrap.dataset.next};
 }
 async function collection(category,signal){
  const base=new URL('/collections/klever-portal-'+(category.parentId?'subcategoria-':'categoria-')+category.id,location.origin);
  base.searchParams.set('section_id','klever-facet-products');
  let next=base.href,total=0;const items=new Map(),visited=new Set();
  while(next){
   if(visited.has(next)||visited.size>=80)throw Error('No pudimos completar el catálogo. Intenta nuevamente.');visited.add(next);
   const result=await page(next,signal,'[data-facet-page]');total=result.total;result.items.forEach(p=>items.set(p.id,p));
   next=result.next;if(next){const u=new URL(next,base);if(u.origin!==base.origin||u.pathname!==base.pathname)throw Error('Página de catálogo inválida.');u.searchParams.set('section_id','klever-facet-products');next=u.href;}
  }
  if(items.size!==total)throw Error('La categoría no se cargó completamente. Intenta nuevamente.');
  return [...items.values()];
 }
 async function hydrate(candidates,signal){
  const skus=[...new Set(candidates.map(p=>p.sku).filter(s=>typeof s==='string'&&/^[\w.-]{1,128}$/.test(s)))];
  const missing=skus.filter(sku=>!cache.has(sku));
  // Bounded batches avoid one request per card and keep URLs comfortably below server limits.
  for(let i=0;i<missing.length;i+=20){
   const u=new URL('/search',location.origin);u.searchParams.set('type','product');u.searchParams.set('options[unavailable_products]','show');u.searchParams.set('q',missing.slice(i,i+20).map(s=>'"'+s+'"').join(' OR '));u.searchParams.set('section_id','klever-search-products');
   await page(u.href,signal,'[data-search-products]');
  }
  // Some compound SKUs (notably Phoenix) are indexed as separate terms. Retry
  // those individually: unquoted OR batches would also match unrelated products.
  const unresolved=missing.filter(sku=>!cache.has(sku));
  for(let i=0;i<unresolved.length;i+=4)await Promise.all(unresolved.slice(i,i+4).map(async sku=>{
   const u=new URL('/search',location.origin);u.searchParams.set('type','product');u.searchParams.set('options[unavailable_products]','show');u.searchParams.set('q',sku);u.searchParams.set('section_id','klever-search-products');await page(u.href,signal,'[data-search-products]');
  }));
  return candidates.map(p=>cache.get(p.sku)).filter(Boolean);
 }
 function fits(p,query){
  const text=normal(query),fields=p.fields;
  const values=key=>(Array.isArray(fields[key])?fields[key]:fields[key]?[fields[key]]:[]).map(normal);
  const cable=/\bcables?\b/.test(text),pins=text.match(/\b(\d{1,2})\s*(?:pines?|polos?)\b/),length=cable?text.match(/\b(\d+(?:[.,]\d+)?)\s*(?:metros?|mts|m)\b/):null;
  const connector=cable?text.match(/\bm(8|12|16|23)\b/):null;
  if(cable&&!/cable|conector/.test(normal(p.category+' '+p.name)))return false;
  if(connector&&values('Formato de conexión').length&&!values('Formato de conexión').includes('m'+connector[1]))return false;
  if(pins&&values('Polos / hilos').length&&!values('Polos / hilos').includes(pins[1]))return false;
  if(length&&values('Longitud').length&&!values('Longitud').some(v=>{
   const measured=v.match(/^(\d+(?:[.,]\d+)?)\s*(mm|cm|m)$/);if(!measured)return false;
   return Number(measured[1].replace(',','.'))*({mm:.001,cm:.01,m:1}[measured[2]])===Number(length[1].replace(',','.'));
  }))return false;
  return true;
 }
 window.KleverSearchProducts={exactCategory,resultCategory,collection,hydrate,fits};
})();
